import { router, Stack } from "expo-router";
import { useState } from "react";
import { View } from "react-native";
import { Button } from "~/components/Button";
import { LoadingMask } from "~/components/feedback/LoadingMask";
import { RadioSelector } from "~/components/form/radio/RadioSelector";
import { OnboardingSkip } from "~/components/layout/home/OnboardingSkip";
import { Page } from "~/components/layout/Page";
import { Subtitle, Title } from "~/components/layout/text";
import { Authorize } from "~/components/permission/Authorize";
import { Nothing } from "~/components/permission/Nothing";
import { Flex, Gap, Margin, Padding } from "~/constants/layout";
import { Font } from "~/constants/typography";
import { useDismiss } from "~/providers/DismissProvider";
import { useFeedback } from "~/providers/FeedbackProvider";
import { useOnboarding } from "~/providers/OnboardingProvider";
import { useProfile } from "~/providers/ProfileProvider";
import { filled } from "~/util";

export default function OnBoarding() {
    const { cycle, updateCycleSettings, profile } = useProfile();
    const { dismiss } = useOnboarding();
    const { handleDismiss } = useDismiss();
    const [tracking, setTracking] = useState("");
    const { saving, setSaving } = useFeedback();

    const saveTracking = async () => {
        if (saving) {
            return;
        }

        dismiss("cycle");

        if (["Yes", "No"].includes(tracking)) {
            setSaving(true);

            await updateCycleSettings({
                ...cycle,
                tracked: tracking === "Yes",
            }).finally(() => setSaving(false));
        }

        tracking === "Yes" ? router.replace("/on-boarding/cycle-length") : handleDismiss();
    };

    if (!profile.permissions) {
        return (
            <Page gradient spacer>
                <LoadingMask />
            </Page>
        );
    }

    return (
        <>
            <Stack.Screen
                options={{
                    headerLeft: () => <Nothing />,
                    headerRight: () => <OnboardingSkip next="/dashboard" />,
                }}
            />
            <Authorize ability="update" section="cycle">
                <Page gradient spacer>
                    <View style={[Flex.between, Flex.grow, Padding.bottom_xxl]}>
                        <View style={[Gap.xxl, Padding.horizontal_xs]}>
                            <View style={Gap.md}>
                                <Title size="xl">Nice to meet you, {profile.name}</Title>
                                <Subtitle size="lg" colour="primary">
                                    We&apos;re glad you&apos;re here 💙
                                </Subtitle>
                            </View>
                            <RadioSelector
                                title="Would you like to set up cycle tracking?"
                                options={["Yes", "No", "Maybe later"]}
                                value={tracking}
                                onValueChange={setTracking}
                                labelStyle={[Font.semibold, Font.xl, Margin.bottom_xxs]}
                                disabled={filled(saving)}
                            />
                        </View>
                        <View style={Padding.horizontal_md}>
                            <Button
                                title="Continue"
                                variant="primary"
                                size="lg"
                                disabled={!tracking}
                                onPress={saveTracking}
                            />
                        </View>
                    </View>
                </Page>
            </Authorize>
        </>
    );
}
